import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card } from '@node-space/ui-components'
import { EarnSummaryItem, EarnSummaryItemVariant } from '../EarnSummaryItem'
import { EarnEmbeddedLabelValueRow } from './EarnEmbeddedLabelValueRow'

export interface EarnEmbeddedMyRewardsProps {
  allocatedFunds: string
  availableFunds: string
  isStatisticsLoading?: boolean
  totalEarnings: string
  allocationEarnings: string
  customerEarnings: string
}

export const EarnEmbeddedMyRewards = ({
  allocatedFunds,
  availableFunds,
  isStatisticsLoading,
  totalEarnings,
  allocationEarnings,
  customerEarnings,
}: EarnEmbeddedMyRewardsProps) => {
  const { t } = useTranslation()

  return (
    <Card
      variant="static"
      full
      borderRadius={12}
      testId="earn-my-rewards"
      className="bg-surface-interactive"
    >
      <Box flexCol gap={16}>
        <h4 className="text-h4 text-foreground-prominent">{t('earn.myRewardsTitle')}</h4>

        <Box flex gap={16} align="start" className="max-sm:flex-col" testId="earn-funds-overview">
          <EarnSummaryItem
            label={t('earn.myAllocatedFunds')}
            value={allocatedFunds}
            variant={EarnSummaryItemVariant.LARGE}
            tooltipContent={t('earn.myAllocatedFundsTooltip')}
          />
          <EarnSummaryItem
            label={t('earn.myUnallocatedFunds')}
            value={availableFunds}
            variant={EarnSummaryItemVariant.LARGE}
            isLoading={isStatisticsLoading}
            testId="earn-available-funds"
            tooltipContent={t('earn.myUnallocatedFundsTooltip')}
          />
        </Box>

        <Box className="w-full border-t border-stroke-static" />

        <Box flexCol gap={4}>
          <EarnEmbeddedLabelValueRow
            testId="earn-total-all-time-earnings"
            label={t('earn.myTotalAllTimeEarnings')}
            value={totalEarnings}
            labelVariant="emphasis"
            valueVariant="success"
          />
          <EarnEmbeddedLabelValueRow
            testId="earn-from-my-allocation"
            label={t('earn.fromMyAllocation')}
            value={allocationEarnings}
          />
          <EarnEmbeddedLabelValueRow
            testId="earn-from-customers"
            label={t('earn.fromCustomers')}
            value={customerEarnings}
          />
        </Box>
      </Box>
    </Card>
  )
}
